import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpProposalListLink } from '@/components/modules/pages/mypage/professional/List/ProfessionalRfpProposalList/ActionLink';
import { Tooltip } from '@/components/ui/Tooltip/Tooltip';
import { Text } from '@/components/ui/Typography/Body/Text';
export const ProfessionalRfpProposalListNegotiateLink = (props) => {
    const { badgeNumber, disabled = false, href, isNegotiable } = props;
    return (_jsx(Tooltip, Object.assign({ arrow: true, html: !isNegotiable || disabled ? (_jsx(Text, Object.assign({ className: 'py-8 px-4', color: 'none', isBold: true, size: 'xs' }, { children: !isNegotiable
                ? '相談可能な条件がありません'
                : '提案意向の登録が必要です' }))) : undefined, position: 'top' }, { children: _jsx(ProfessionalRfpProposalListLink, { badgeNumber: badgeNumber, className: '!inline-flex', color: 'navy', disabled: disabled, href: href, text: '相談する' }) })));
};
